module.exports = __webpack_public_path__ + "img/frame (167).8ab9aa8f.jpg";